/** InsCoder WANG.J 2026-08-06 B + In-store availability store row accordion **/
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cust-in-store-availability').forEach(function(container) {
    const rows = container.querySelectorAll('.cust-in-store-availability__row');
    rows.forEach(function(row) {
      const trigger = row.querySelector('.cust-in-store-availability__row-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        const isOpen = row.classList.contains('is-open');
        rows.forEach(function(otherRow) {
          otherRow.classList.remove('is-open');
          const otherTrigger = otherRow.querySelector('.cust-in-store-availability__row-trigger');
          if (otherTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        if (!isOpen) {
          row.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
});
/** InsCoder WANG.J 2026-08-06 E + In-store availability store row accordion **/
